/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateOrganizationPaymentScheduleBillingInvoiceResponseDataFromJSON, CreateOrganizationPaymentScheduleBillingInvoiceResponseDataToJSON } from './CreateOrganizationPaymentScheduleBillingInvoiceResponseData';
export function CreateOrganizationPaymentScheduleBillingInvoiceResponseFromJSON(json) {
    return CreateOrganizationPaymentScheduleBillingInvoiceResponseFromJSONTyped(json, false);
}
export function CreateOrganizationPaymentScheduleBillingInvoiceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: CreateOrganizationPaymentScheduleBillingInvoiceResponseDataFromJSON(json['data'])
    };
}
export function CreateOrganizationPaymentScheduleBillingInvoiceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: CreateOrganizationPaymentScheduleBillingInvoiceResponseDataToJSON(value.data)
    };
}
